import { useContext } from 'react';

import { Spinner } from '@pulse-web-ui/spinner';

import { Product } from '@src/constants';
import { Store } from '@src/store';

import { SkeletonWrapper } from './skeleton.styles';

const MITE_SKELETON_SIZE = 44;

export const Skeleton = () => {
  const {
    state: {
      stateUser: { selectedProduct },
    },
  } = useContext(Store);
  const skeletonSize =
    selectedProduct === Product.MITE ? MITE_SKELETON_SIZE : undefined;

  return (
    <SkeletonWrapper>
      <Spinner size={skeletonSize} />
    </SkeletonWrapper>
  );
};
